import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { IApikey, IFilter, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';

import { ApikeysService } from '../apikeys.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { IRegExpSearch } from '../../../../../auxiliares/tabla/filtro/filtro.component';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../../auxiliares/tabla/tabla.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { FormularioDialogService } from '../../../../../auxiliares/servicios/formulario-dialog.service';
import { CrearEditarApikeyComponent } from '../crear-editar-apikey/crear-editar-apikey.component';

@Component({
  selector: 'app-apikeys',
  templateUrl: './apikeys.component.html',
  standalone: false,
})
export class ApikeysComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(ApikeysService);
  private formularios = inject(FormularioDialogService);

  //// Tabla nueva
  public name = 'ApikeysComponent';
  public apikeys: IApikey[] = [];
  public apikeys$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IApikey>[];
  public botonCrear: ICrearBoton = {
    mostrar: this.helper.tienePermiso('Administración - Crear apikeys'),
    tooltip: 'Crear apikey',
    color: 'primary',
    tipo: 'material',
    icon: 'add',
    accion: () => this.crear(),
  };
  public search: IRegExpSearch = {
    fields: ['identificacion'],
  };

  public filter: IFilter<IApikey> = {};
  public query: IQueryParam = {
    filter: JSON.stringify(this.filter),
    sort: 'identificacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    this.apikeys$?.unsubscribe();
    this.apikeys$ = this.lista2.apikeys(this.query, 30).subscribe((data) => {
      this.totalCount = data.totalCount;
      this.apikeys = data.datos;
    });
  }

  // Acciones
  // Crear y editar se abren en modal; al cerrar con resultado se refresca
  public crear() {
    this.abrirFormulario();
  }

  public editar(apikey: IApikey) {
    this.abrirFormulario(apikey);
  }

  private abrirFormulario(apikey?: IApikey) {
    this.formularios
      .abrir(CrearEditarApikeyComponent, {
        tamano: 'chico',
        data: apikey ? { edit: apikey } : undefined,
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) this.listar();
      });
  }

  public async eliminar(apikey: IApikey) {
    const res = await this.dialogService.confirm(
      'Eliminar apikey',
      `¿Querés eliminar el apikey ${apikey.key}?`,
    );
    if (!res) return;
    try {
      await this.service.delete(apikey._id!);
      this.helper.notifSuccess('Apikey eliminada');
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Identificación',
        },
        row: {
          field: 'identificacion',
        },
      },
      {
        header: {
          label: 'Global',
        },
        row: {
          // Es un dato, no un estado: Sí / No como texto
          parse: (dato) => (dato.global ? 'Sí' : 'No'),
        },
      },
      {
        header: {
          label: 'Llave',
        },
        // La llave se ve enmascarada, con mostrar y copiar
        row: {
          secretos: (dato) =>
            dato.key ? [{ secreto: dato.key, que: 'Llave' }] : undefined,
          noData: 'Sin llave',
        },
      },
      {
        header: {
          label: 'Acciones',
        },
        row: {
          acciones: [
            {
              tipo: 'material',
              color: 'primary',
              icon: 'edit',
              tooltip: 'Editar',
              click: (dato) => this.editar(dato),
              disabled: () =>
                !this.helper.tienePermiso('Administración - Editar apikeys'),
            },
            {
              tipo: 'material',
              color: 'warn',
              icon: 'delete',
              tooltip: 'Eliminar',
              click: (dato) => this.eliminar(dato),
              disabled: () =>
                !this.helper.tienePermiso('Administración - Eliminar apikeys'),
            },
          ],
        },
      },
    ];
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.apikeys$?.unsubscribe();
  }
}
